// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__dPFsY","menuLink":"styles_menuLink__S0LEQ","menuButton":"styles_menuButton__kaHiP"};